import {type ParserT, record, number, Parser} from '@freckle/parser'
import {ajaxJsonCall} from '@freckle/student-entities/ts/common/helpers/ajax'
import CApiHelper from '@freckle/student-entities/ts/common/helpers/common-api-helper'
import {type UnixTimespanT} from '@freckle/student/ts/common/logic/assignments'

type IncompleteAssignmentCountT = {
  count: number
}

const parse: ParserT<IncompleteAssignmentCountT> = record({
  count: number()
})

const parseIncompleteAssignmentCount = Parser.mkRun<IncompleteAssignmentCountT>(parse)

export async function fetchIncompleteAssignmentCount({
  mathStandardSetId,
  timespan,
  unified
}: {
  mathStandardSetId: string
  timespan?: UnixTimespanT | null
  unified?: 'True' | 'False' // this is how Haskell capitalizes stuff on the backend
}): Promise<IncompleteAssignmentCountT> {
  const baseQuery = timespan ?? null
  const query = unified !== undefined ? {...baseQuery, unified} : baseQuery
  return ajaxJsonCall({
    query,
    url: `${CApiHelper.fancyPaths.v2.students.me_incomplete_assignment_count()}?math-standard-set-id=${mathStandardSetId}`,
    method: 'GET'
  }).then(parseIncompleteAssignmentCount)
}
